import { Box } from '@mui/material'

import { BookingAddressType } from 'generated/graphql'

import {
  DeliveryJourneyDetails,
  DeliverySuccess,
  LegalDocuments,
  PackageDetails,
  DeliveryFeedbackActions,
  ProofButton,
} from './ui'

interface CompletedTrackingSectionProps {
  booking?: any
  bookingCurrentAction?: any
  nextBookingAction?: any
  collectionTime?: string
  deliveryTime?: string
  referenceAddressType?: BookingAddressType | null
  collectionAttachmentCount?: number
  deliveryAttachmentCount?: number
  combinedDocAttachmentCount?: number
  onDetailsClick?: () => void
  onProofOfCollectionClick?: () => void
  onProofOfDeliveryClick?: () => void
  onCombinedDocsClick?: () => void
  talkToAnExpertUrl: string
}

const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  px: 2,
  py: 3,
  gap: 2,
  height: '100%',
}

const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
}

const proofButtonRowStyles = {
  display: 'flex',
  gap: 1,
}

export const CompletedTrackingSection = ({
  booking,
  bookingCurrentAction,
  nextBookingAction,
  collectionTime,
  deliveryTime,
  referenceAddressType,
  collectionAttachmentCount = 0,
  deliveryAttachmentCount = 0,
  combinedDocAttachmentCount = 0,
  onDetailsClick,
  onProofOfCollectionClick,
  onProofOfDeliveryClick,
  onCombinedDocsClick,
  talkToAnExpertUrl,
}: CompletedTrackingSectionProps) => {
  const isCollectionLink = referenceAddressType === BookingAddressType.Collection
  const completionType = isCollectionLink ? 'collection' : 'delivery'
  const journeyStatus = isCollectionLink ? 'Collected' : 'Delivered'

  const showCollectionProof = collectionAttachmentCount > 0
  const showDeliveryProof = deliveryAttachmentCount > 0
  const showCombinedDocs = referenceAddressType == null && combinedDocAttachmentCount > 0
  const showProofButtons = showCollectionProof || showDeliveryProof || showCombinedDocs

  return (
    <Box sx={containerStyles}>
      <Box sx={contentWrapperStyles}>
        <LegalDocuments
          ourReference={booking?.ourReference}
          bookingCurrentAction={bookingCurrentAction}
          nextBookingAction={nextBookingAction}
        />

        <DeliverySuccess
          collectionTime={collectionTime}
          deliveryTime={deliveryTime}
          completionType={completionType}
        />

        {showProofButtons && (
          <>
            <Box sx={proofButtonRowStyles}>
              {showCollectionProof && (
                <ProofButton label='Proof of Collection' onClick={onProofOfCollectionClick} />
              )}
              {showDeliveryProof && (
                <ProofButton label='Proof of Delivery' onClick={onProofOfDeliveryClick} />
              )}
            </Box>
            <Box>
              {showCombinedDocs && (
                <ProofButton
                  label='Combined Proof of Service Documents'
                  onClick={onCombinedDocsClick}
                />
              )}
            </Box>
          </>
        )}

        <DeliveryJourneyDetails status={journeyStatus} />

        <PackageDetails onDetailsClick={onDetailsClick} />
      </Box>

      <DeliveryFeedbackActions talkToAnExpertUrl={talkToAnExpertUrl} />
    </Box>
  )
}
